"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuIcon = exports.MenuHeader = exports.MenuDelimiter = exports.MenuLink = exports.MenuItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf5 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRouterDom = require("react-router-dom");

var _DropDown = _interopRequireWildcard(require("../DropDown"));

var _Hotkey = _interopRequireDefault(require("../Hotkey"));

require("./menu.sass");

var MenuItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MenuItem, _React$Component);

  function MenuItem() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MenuItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf5.default)(MenuItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onClick", function (e) {
      if (_this.props.disabled) {
        return;
      }

      _this.props.onClick && _this.props.onClick(e);

      if (_this.context.hidePopup) {
        _this.context.hidePopup();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(MenuItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          Icon = _this$props.Icon,
          shortcut = _this$props.shortcut,
          scope = _this$props.scope,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          disabled = _this$props.disabled,
          selectable = _this$props.selectable,
          children = _this$props.children,
          isHovered = _this$props.isHovered;
      return _react.default.createElement("div", {
        onClick: this.onClick,
        className: (0, _classnames.default)('menu-item', className, {
          'menu-item--disabled': disabled,
          'menu-item--selectable': selectable,
          'menu-item--hover': !disabled && isHovered
        }),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
      }, isHovered && _react.default.createElement(_Hotkey.default, {
        shortcut: "enter",
        action: this.onClick,
        scope: scope
      }), shortcut && _react.default.createElement(_Hotkey.default, {
        shortcut: shortcut,
        action: this.onClick,
        scope: scope
      }), Icon && _react.default.createElement(Icon, {
        className: "menu-item-icon"
      }), children);
    }
  }]);
  return MenuItem;
}(_react.default.Component);

exports.MenuItem = MenuItem;
(0, _defineProperty2.default)(MenuItem, "contextTypes", {
  hidePopup: _propTypes.default.func
});
(0, _defineProperty2.default)(MenuItem, "defaultProps", {
  selectable: true
});
MenuItem.propTypes = process.env.NODE_ENV !== "production" ? {
  selectable: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  shortcut: _propTypes.default.string,
  Icon: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
  onClick: function onClick(props) {
    var test = props.disabled ? _propTypes.default.func : _propTypes.default.func.isRequired;

    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return test.apply(this, [props].concat(args));
  }
} : {};

var MenuLinkComponent =
/*#__PURE__*/
function (_MenuItem) {
  (0, _inherits2.default)(MenuLinkComponent, _MenuItem);

  function MenuLinkComponent() {
    var _getPrototypeOf3;

    var _this2;

    (0, _classCallCheck2.default)(this, MenuLinkComponent);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this2 = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf3 = (0, _getPrototypeOf5.default)(MenuLinkComponent)).call.apply(_getPrototypeOf3, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this2)), "onClick", function (e) {
      if (_this2.props.disabled) {
        return;
      }

      _this2.props.history.push(_this2.props.to);

      if (_this2.context.hidePopup) {
        _this2.context.hidePopup();
      }
    });
    return _this2;
  }

  return MenuLinkComponent;
}(MenuItem);

MenuLinkComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  selectable: _propTypes.default.bool,
  disabled: _propTypes.default.bool
} : {};
var MenuLink = (0, _reactRouterDom.withRouter)(MenuLinkComponent);
exports.MenuLink = MenuLink;

var _ref = _react.default.createElement("div", {
  className: "menu-delimiter"
});

var MenuDelimiter = function MenuDelimiter() {
  return _ref;
};

exports.MenuDelimiter = MenuDelimiter;

var MenuHeader = function MenuHeader(_ref2) {
  var children = _ref2.children;
  return _react.default.createElement("div", {
    className: "menu-header"
  }, children);
};

exports.MenuHeader = MenuHeader;

var MenuIcon = function MenuIcon(_ref3) {
  var Icon = _ref3.Icon,
      className = _ref3.className,
      _ref3$align = _ref3.align,
      align = _ref3$align === void 0 ? _DropDown.ALIGN_TOP | _DropDown.ALIGN_RIGHT : _ref3$align,
      props = (0, _objectWithoutProperties2.default)(_ref3, ["Icon", "className", "align"]);
  return _react.default.createElement(_DropDown.default, {
    trigger: _react.default.createElement(Icon, null),
    align: align,
    className: className
  }, _react.default.createElement(Menu, props));
};

exports.MenuIcon = MenuIcon;

var Menu =
/*#__PURE__*/
function (_React$Component2) {
  (0, _inherits2.default)(Menu, _React$Component2);

  function Menu() {
    var _getPrototypeOf4;

    var _this3;

    (0, _classCallCheck2.default)(this, Menu);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this3 = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf4 = (0, _getPrototypeOf5.default)(Menu)).call.apply(_getPrototypeOf4, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this3)), "state", {
      index: -1
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this3)), "setNext", function (e) {
      e.stopPropagation();
      e.preventDefault();

      _this3.setState(function (_ref4) {
        var index = _ref4.index;

        var children = _react.default.Children.toArray(_this3.props.children);

        for (index = index + 1; index < children.length; index++) {
          if (_this3.isEnabled(children[index])) {
            return {
              index: index
            };
          }
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this3)), "cancel", function (e) {
      if (_this3.context.hidePopup) {
        _this3.context.hidePopup();

        e.stopPropagation();
        e.preventDefault();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this3)), "select", function (index) {
      _this3.setState({
        index: index
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this3)), "setPrev", function (e) {
      e.stopPropagation();
      e.preventDefault();

      _this3.setState(function (_ref5) {
        var index = _ref5.index;

        var children = _react.default.Children.toArray(_this3.props.children);

        for (index = index - 1; index >= 0; index--) {
          if (_this3.isEnabled(children[index])) {
            return {
              index: index
            };
          }
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this3)), "isEnabled", function (child) {
      return child && child.props && !child.props.disabled;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this3)), "renderItem", function (child, index) {
      var props = {
        key: index || child.key,
        isHovered: _this3.state.index === index,
        scope: _this3.props.scope
      };

      if (_this3.isEnabled(child)) {
        props.onMouseEnter = function () {
          return _this3.setState({
            index: index
          });
        };

        props.onMouseLeave = function () {
          return _this3.setState({
            index: -1
          });
        };
      }

      return _react.default.cloneElement(child, props);
    });
    return _this3;
  }

  (0, _createClass2.default)(Menu, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children,
          scope = _this$props2.scope,
          props = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "children", "scope"]);
      return _react.default.createElement("div", (0, _extends2.default)({
        className: (0, _classnames.default)('menu', className)
      }, props), _react.default.createElement(_Hotkey.default, {
        shortcut: "up",
        action: this.setPrev,
        scope: scope
      }), _react.default.createElement(_Hotkey.default, {
        shortcut: "down",
        action: this.setNext,
        scope: scope
      }), _react.default.createElement(_Hotkey.default, {
        shortcut: "esc",
        action: this.cancel,
        scope: scope
      }), _react.default.Children.toArray(children).map(this.renderItem));
    }
  }]);
  return Menu;
}(_react.default.Component);

exports.default = Menu;
(0, _defineProperty2.default)(Menu, "contextTypes", {
  hidePopup: _propTypes.default.func
});
Menu.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.string,
  scope: _propTypes.default.string
} : {};